"use client";

import { isHiddenByActivity, isInHiddenPage } from "@/lib/activePageDom";
import { useEffect } from "react";

// A page Next keeps mounted in a hidden <Activity> keeps playing its audio and video, so pause them when React hides the page and whenever they start while it is hidden.
export function PauseMediaInHiddenPages() {
  useEffect(() => {
    const pauseIfHidden = (event: Event) => {
      if (
        event.target instanceof HTMLMediaElement &&
        isInHiddenPage(event.target)
      ) {
        event.target.pause();
      }
    };
    // Media events do not bubble, so listen in the capture phase.
    document.addEventListener("play", pauseIfHidden, true);
    const observer = new MutationObserver((mutations) =>
      mutations
        .map((mutation) => mutation.target)
        .filter(
          (target): target is Element =>
            target instanceof Element && isHiddenByActivity(target)
        )
        .flatMap((element) => [
          element,
          ...Array.from(element.querySelectorAll("audio, video")),
        ])
        .filter(
          (element): element is HTMLMediaElement =>
            element instanceof HTMLMediaElement
        )
        .forEach((media) => media.pause())
    );
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
      subtree: true,
    });
    return () => {
      observer.disconnect();
      document.removeEventListener("play", pauseIfHidden, true);
    };
  }, []);
  return null;
}
